import { ShowedContentType } from '@/shared/types'

export const getShowedContentType = (
	isPending: boolean,
	isError: boolean,
	data: unknown | undefined
): ShowedContentType => {
	if (isPending) {
		return ShowedContentType.skeleton
	}

	if (!data && !isError) {
		throw new Error('isData and isError not active at the same time')
	}

	if (data && isError) {
		throw new Error('isData and isError is active at the same time')
	}

	if (isError) {
		return ShowedContentType.error
	}

	return ShowedContentType.content
}
